



























import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
   components: {
    Header,
    Menu,
    NextPrevBtn,
    Footer,
   }
})
export default class LetterAnalysis extends Vue {
  protected nxtprevLetterAnalysis =
  {
    BoolPrev: true,
    BoolNext: true,
    PrevImage: "/thumbnail6.png",
    NextImage: "/thumbnail1.png",
    PrevLink: "/Lettre_de_Motivation/Astuces",
    NextLink: "/Lettre_de_Motivation/Arguments",
  };
}
